module.exports = function() {
  return new Worker(__webpack_public_path__ + "3b70b57d95bfafe92595.worker.js");
};